export {default as create} from "./create";
export {default as creator} from "./creator";
export {default as local} from "./local";
export {default as matcher} from "./matcher";
export {default as mouse} from "./mouse";
export {default as namespace} from "./namespace";
export {default as namespaces} from "./namespaces";
export {default as clientPoint} from "./point";
export {default as select} from "./select";
export {default as selectAll} from "./selectAll";
export {default as selection} from "./selection/index";
export {default as selector} from "./selector";
export {default as selectorAll} from "./selectorAll";
export {styleValue as style} from "./selection/style";
export {default as touch} from "./touch";
export {default as touches} from "./touches";
export {default as window} from "./window";
export {event, customEvent} from "./selection/on";



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/index.js
// module id = ./node_modules/d3-selection/src/index.js
// module chunks = 53